import {Component} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {distinctUntilChanged, filter, map, startWith} from 'rxjs/operators';
import {BreadCrumb} from './breadcrumb';

@Component({
  selector: 'gt-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  breadcrumbs$: Observable<BreadCrumb[]> = this.router.events.pipe(
    startWith(new NavigationEnd(0, '/', '/')),
    filter(event => event instanceof NavigationEnd),
    distinctUntilChanged(),
    map(() => this.buildBreadCrumb(this.activatedRoute.root))
  );

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router) {
  }

  buildBreadCrumb(route: ActivatedRoute, url: string = '',
                  breadcrumbs: Array<BreadCrumb> = []): Array<BreadCrumb> {
    // Check for signs of home crumb
    let label: string;
    if (route != null && route.routeConfig != null) {
      if (route.routeConfig.data != null) {
        label = route.routeConfig.data.label;
      }
    } else {
      label = 'global.home';
    }

    // Do not show breadcrumb if label not defined, unless it's the home crumb
    let show = false;
    if ((route != null &&
      route.routeConfig != null &&
      route.routeConfig.data != null &&
      route.routeConfig.data.label) ||
      (label != null && label.toLowerCase() === 'global.home')) {
      show = true;
    }

    const path = route.routeConfig ? route.routeConfig.path : '';

    // In the routeConfig the complete path is not available, so we rebuild it
    // each time
    const nextUrl = `${url}${path}/`;
    const breadcrumb = {
      label,
      url: nextUrl,
      show
    };
    const newBreadcrumbs = [...breadcrumbs, breadcrumb];

    if (route.firstChild) {
      // If we are not on our current path yet, there will be more children to
      // look after, to build our breadcumb
      return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
    }
    return newBreadcrumbs;
  }
}
